import { render, staticRenderFns } from "./SoccerScoresLineups.vue?vue&type=template&id=60bde1fb&"
import script from "./SoccerScoresLineups.vue?vue&type=script&lang=js&"
export * from "./SoccerScoresLineups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports